/** Etiquetas (o DTO e o input do CRUD). */
import { z } from "zod";
import { uuid } from "./common.js";

/* ---------- Etiquetas ---------- */
export const label = z.object({
  id: uuid,
  name: z.string(),
  color: z.string(),
  description: z.string().nullable().optional(),
  /** Contagem de conversas ativas que usam a etiqueta (docs/07). */
  conversations: z.number().int().nonnegative().optional(),
});
export type Label = z.infer<typeof label>;

export const labelInput = z.object({
  id: uuid.optional(),
  name: z.string().min(1).max(40),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  description: z.string().max(160).optional(),
});
export type LabelInput = z.infer<typeof labelInput>;
